module.exports = __webpack_public_path__ + "media/src/images/dandori/step5-a575c331d0807b736d0afe986e24c9b5.png";